// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"a35beb6e","204":"79693b6a"}[chunkId] + ".chunk.css";
};